/**
 * @generated SignedSource<<7293d8ecd88ece9cf44392fe9dae3016>>
 * @relayHash be3ffe57a6699e732683a057c27d3dd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 69d6526f56dacd1d3663ac1b0f60b3fe2342071cc2be9ec7370b35eb81408f57

import type { ConcreteRequest } from 'relay-runtime';
export type CreateAgentCardWithQueryAgentByIdQuery$variables = {
  agentAri: string;
  cloudId: string;
};
export type CreateAgentCardWithQueryAgentByIdQuery$data = {
  readonly agentStudio_agentById: {
    readonly __typename: "AgentStudioAssistant";
    readonly description: string | null;
    readonly externalConfigReference: string | null;
    readonly icon: string | null;
    readonly id: string;
    readonly identityAccountId: string | null;
    readonly instructions: string | null;
    readonly isPublished: boolean;
    readonly knowledgeSources: {
      readonly enabled: boolean | null;
      readonly sources: ReadonlyArray<{
        readonly enabled: boolean | null;
        readonly filters: {
          readonly parentFilter?: ReadonlyArray<string> | null;
          readonly projectFilter?: ReadonlyArray<string> | null;
          readonly spaceFilter?: ReadonlyArray<string> | null;
        } | null;
        readonly source: string;
      }> | null;
    } | null;
    readonly name: string | null;
    readonly tools: ReadonlyArray<{
      readonly description: string | null;
      readonly displayName: string | null;
      readonly iconUrl: string | null;
      readonly id: string;
      readonly tags: ReadonlyArray<string> | null;
    }> | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly agentStudio_hasVersionCapability: {
    readonly __typename: "AgentStudioHasVersionCapability";
    readonly hasVersionCapability: boolean | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type CreateAgentCardWithQueryAgentByIdQuery = {
  response: CreateAgentCardWithQueryAgentByIdQuery$data;
  variables: CreateAgentCardWithQueryAgentByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }
  ],
  "kind": "LinkedField",
  "name": "agentStudio_hasVersionCapability",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasVersionCapability"
        }
      ],
      "type": "AgentStudioHasVersionCapability"
    }
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "description"
},
v7 = {
  "kind": "ScalarField",
  "name": "instructions"
},
v8 = {
  "kind": "ScalarField",
  "name": "icon"
},
v9 = {
  "kind": "ScalarField",
  "name": "identityAccountId"
},
v10 = {
  "kind": "ScalarField",
  "name": "externalConfigReference"
},
v11 = {
  "kind": "ScalarField",
  "name": "isPublished"
},
v12 = {
  "concreteType": "AgentStudioTool",
  "kind": "LinkedField",
  "name": "tools",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    {
      "kind": "ScalarField",
      "name": "tags"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "enabled"
},
v14 = {
  "kind": "ScalarField",
  "name": "source"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "spaceFilter"
    },
    {
      "kind": "ScalarField",
      "name": "parentFilter"
    }
  ],
  "type": "AgentStudioConfluenceKnowledgeFilter"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectFilter"
    }
  ],
  "type": "AgentStudioJiraKnowledgeFilter"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CreateAgentCardWithQueryAgentByIdQuery",
    "selections": [
      (v2/*: any*/),
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "kind": "LinkedField",
          "name": "agentStudio_agentById",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v4/*: any*/),
                  "action": "THROW"
                },
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v12/*: any*/),
                {
                  "concreteType": "AgentStudioKnowledgeConfiguration",
                  "kind": "LinkedField",
                  "name": "knowledgeSources",
                  "plural": false,
                  "selections": [
                    (v13/*: any*/),
                    {
                      "concreteType": "AgentStudioKnowledgeSource",
                      "kind": "LinkedField",
                      "name": "sources",
                      "plural": true,
                      "selections": [
                        (v13/*: any*/),
                        (v14/*: any*/),
                        {
                          "kind": "LinkedField",
                          "name": "filters",
                          "plural": false,
                          "selections": [
                            (v15/*: any*/),
                            (v16/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ],
              "type": "AgentStudioAssistant"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateAgentCardWithQueryAgentByIdQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentById",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "concreteType": "AgentStudioKnowledgeConfiguration",
                "kind": "LinkedField",
                "name": "knowledgeSources",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "concreteType": "AgentStudioKnowledgeSource",
                    "kind": "LinkedField",
                    "name": "sources",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "filters",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "AgentStudioAssistant"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "69d6526f56dacd1d3663ac1b0f60b3fe2342071cc2be9ec7370b35eb81408f57",
    "metadata": {},
    "name": "CreateAgentCardWithQueryAgentByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f07f77bf3c4b3c57c244f3b14cee3d23";

export default node;
